export const residentialStatusSelectOptions = [
    { id: 1, label: 'Resident', value: 'resident' },
    { id: 2, label: 'Non resident', value: 'non_resident' },
];
